module.exports = __webpack_public_path__ + "img/51mg.37036071.png";